"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStyleModule = exports.processStyleModule = void 0;
function processStyleModule(styles) {
    var css = styles._getCss;
    var styleId = styles._meta.moduleId;
    var order = styles._meta.order;
    // if (styles._debug.resourcePath.includes('card/card.scss')) {
    //   console.log('included', styles._debug.resourcePath);
    // }
    return { css: css, styleId: styleId, order: order };
}
exports.processStyleModule = processStyleModule;
function isStyleModule(styles) {
    return '_getCss' in styles;
}
exports.isStyleModule = isStyleModule;
//# sourceMappingURL=utils.js.map